import { useQuery } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import { getCountryName } from "common/helpers/utils";

async function getProxiesRequest(workspaceId: string): Promise<{
  proxies: { country: string; countryCode: string }[];
  suggestedCountryCode: string;
}> {
  const { countries, country_code: suggestedCountryCode } = await get(
    `workspaces/${workspaceId}/proxies`,
  );
  return {
    proxies: countries.map((countryCode: string) => ({
      country: getCountryName(countryCode),
      countryCode,
    })),
    suggestedCountryCode,
  };
}

export default function useProxies() {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { data, isLoading: isLoadingProxies } = useQuery({
    queryKey: ["proxies", workspaceId],
    queryFn: () => getProxiesRequest(workspaceId),
  });

  // Sort proxies alphabetically by country name
  const proxies = data
    ? data.proxies.sort((a, b) =>
        a.country.localeCompare(b.country, "en", { ignorePunctuation: true }),
      )
    : [];

  return {
    proxies,
    isLoadingProxies,
    suggestedCountryCode: data?.suggestedCountryCode,
  };
}
